/*
  mis-click-count.js

  Give a model the ability to count
  every time a specifed element is
  clicked by recording it in MIS
  by means of a hidden field in the model.

  Copyright: Berkeley Bridge 2021
  Author: Tim Bauwens
*/

import * as R from "ramda";
import { bb } from "$json";
import { getmetadata } from "$json/lib/getmetadata";

const getIDbykey = (items = [], key = "") => {
  const arr = [...items];
  if (!arr.length) return null;
  const item = arr.pop();
  if (item.length) {
    return R.has(key)(item[1]) ? item[0][0] : getIDbykey(arr, key);
  } else {
    return null;
  }
};

((doc, $) => {
  let clickelem = false;
  let clickfield = false;

  const clicked = e => {
    try {
      doc.querySelector(`[data-id="${clickfield}"]`).value = "true";
      bb.updatemis();
    } catch (err) {
      window.console && window.console.warn(err);
    }
  };

  $(doc).on("bb:preHandleData", (e, data) => {
    if (data && data.groups && data.groups.length) {
      const mdprops = getmetadata(data).props;
      const mdcontrols = getmetadata(data).controls;
      if (
        mdprops.has("p-mis-click-count") &&
        mdprops.has("p-mis-click-count-field")
      ) {
        const items = [...mdcontrols];
        if (mdprops.get("p-mis-click-count") === "end-tools-document") {
          clickelem = "end-tools-document";
        } else {
          clickelem = getIDbykey(items, "p-mis-click-count");
        }
        clickfield = getIDbykey(items, "p-mis-click-count-field");
      } else {
        clickelem = clickfield = false;
      }
    }
  });

  $(doc).on("bb:finalHandleData", (e, data) => {
    if (data && data.groups && data.groups.length) {
      if (clickelem && clickfield) {
        // First switch values from ID to data-id, which are no longer the same.
        clickfield = doc.getElementById(clickfield).getAttribute("data-id");

        if (clickelem === "end-tools-document") {
          doc
            .querySelector(".bb-p-end-tools-container .download-container a")
            .addEventListener("click", clicked);
        } else {
          // First switch values from ID to data-id, which are no longer the same.
          clickelem = doc.getElementById(clickelem).getAttribute("data-id");

          doc.querySelectorAll(`[data-id="${clickelem}"]`).forEach(elem => {
            elem.addEventListener("click", clicked);
          });
        }

        try {
          doc
            .querySelector(`[data-id="${clickfield}"]`)
            .closest(".bb-questionlabelgroup").style.display = "none";
        } catch (_err) {
          // Probably this is not in a bb-questionlabelgroup...
          doc
            .querySelector(`[data-id="${clickfield}"]`)
            .closest(".bb-input-wrap").style.display = "none";
        }
      }
    }
  });
})(document, jQuery);
